module.exports = __webpack_public_path__ + "img/WarningCircle.9a9309d1.svg";